import styled from 'styled-components/macro';
import * as colors from 'components/common/colorConstants';
import * as animations from 'components/common/animations';

export const SelectOptionsWrapper = styled.div`
  padding: 78px 90px 106px;
  display: flex;
  flex-direction: column;
  background-color: ${colors.baseBackground};
  border-bottom: 1px solid ${colors.lightGray21};

  p {
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: ${colors.blue1};
    margin-bottom: 41px;
    text-align: center;
    ${animations.fadeInSlow}
  }
`;

export const HeaderWrapper = styled.div`
  padding: 53px 130px 47px 30px;
  background-color: ${colors.baseBackground};
  position: relative;
  margin: 0px 0px 10px;

  h1 {
    font-style: normal;
    font-weight: 400;
    font-size: 14px !important;
    line-height: 17px;
    letter-spacing: -0.1px;
    margin-bottom: 22px !important;
    font-family: 'Roboto', sans-serif;
    color: ${colors.darkGray1};
    width: 235px;
  }

  p {
    font-style: normal;
    font-weight: normal;
    font-size: 10px !important;
    line-height: 16px;
    font-family: 'Roboto', sans-serif;
    color: ${colors.darkGray1};
    margin: 0px;
    padding: 0px;
  }

  img {
    position: absolute;
    right: 12px;
    top: 25px;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
